(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/constants.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/constants.js');
'use strict';

const isServer = typeof exports === 'object';
const DEPOSIT_PAY_SUPPORTED_PRODUCTS = ['spela-tillsammans', 'lyckoplatsen', 'lotto', 'keno', 'eurojackpot', 'vikinglotto', 'triss', 'skrapspel'];
if (isServer) {
  module.exports = {
    DEPOSIT_PAY_SUPPORTED_PRODUCTS
  };
} else {
  svs.accountservicesReact.deposit.constants.DEPOSIT_PAY_SUPPORTED_PRODUCTS = DEPOSIT_PAY_SUPPORTED_PRODUCTS;
  svs.accountservicesReact.deposit.constants.SWEDBANKPAY_CONTAINER_ELEMENT = 'js-swedbank-pay-container';
  svs.accountservicesReact.deposit.constants.paymentTypes = {
    APPLEPAY: 'applepay',
    BANKCARD: 'creditcard',
    SWISH: 'swish',
    SWEDBANKEXPRESS: 'swedbankexpress'
  };
  svs.accountservicesReact.deposit.constants.swishstatus = {
    OK: 'ok',
    ERROR_SWISH: 'errorswish',
    ERROR_INTERNAL: 'errorinternal'
  };
  svs.accountservicesReact.deposit.constants.amountLimits = {
    MIN: 25,
    MAX: 25000
  };
  svs.accountservicesReact.deposit.constants.swedbankExpress.displayStatus = {
    SUCCESS: 'success',
    ERROR: 'error',
    CANCEL: 'cancel',
    LOADER: 'loader',
    BANKID_AUTH_QRCODE: 'bankidauthqrcode',
    BANKID_AUTH_WAIT: 'bankidauthwait',
    BANKID_AUTH_WAIT_APP: 'bankidauthwaitapp',
    BANKID_AUTH_APP: 'bankidauthapp',
    BANKID_DEBIT_QRCODE: 'bankiddebitqrcode',
    BANKID_DEBIT_WAIT: 'bankiddebitwait',
    BANKID_DEBIT_WAIT_APP: 'bankiddebitwaitapp',
    BANKID_DEBIT_APP: 'bankiddebitapp',
    NEW_CUSTOMER: 'newcustomer',
    EXPIRED_TOKEN: 'brokentoken',
    CHANGE_BANK: 'changebank',
    CONSENT_SELECT_BANK: 'consentselectbank',
    CONSENT_SELECT_BANK_WAIT: 'consentselectbankwait',
    CONSENT_SELECT_BANK_WAIT_APP: 'consentselectbankwaitapp'
  };
  svs.accountservicesReact.deposit.constants.swedbankExpress.backendErrorCodes = {
    NOT_USED: 0,
    GENERAL_ERROR: 1,
    TRY_AGAIN: 3,
    CUSTOMER_CANCELLED: 8,
    MISSING_TOKEN: 10,
    EXPIRED_REFRESH_TOKEN: 11,
    CUSTOMER_HAS_MULTIPLE_BANKS: 12,
    DEPOSIT_ABOVE_LIMIT: 20,
    DEPOSIT_BELOW_LIMIT: 21,
    DEPOSIT_BUDGET_NOT_SET: 22,
    DEPOSIT_DAY_LIMIT_EXCEEDED: 23,
    DEPOSIT_WEEK_LIMIT_EXCEEDED: 24,
    DEPOSIT_MONTH_LIMIT_EXCEEDED: 25,
    DEPOSIT_SUSPENDED: 27,
    NOT_A_CUSTOMER_IN_SWD_GROUP: 40,
    NOT_A_CUSTOMER_IN_SWD_SUBSIDIARY: 41,
    USER_CONTACT_SWEDBANK: 42,
    CUSTOMER_CONTACT_BANK_KYC: 44,
    INSUFFICIENT_FUND: 50,
    NO_MORE_QR_IMAGE: 60,

    ONGOING_RETAIL_PURCHASE: 62,
    WILL_EXCEED_MAX_DEPOSIT: 63,

    BANKID_CANCELED: 70,
    JUPITER_NETWORK_ERROR: 666,
    DUMMY: 0
  };

  svs.accountservicesReact.deposit.constants.swedbankExpress.oauthStatus = {
    oauth2sts_NONE: 0,
    oauth2sts_UNKNOWN_INTERNAL_ISSUE: 1,
    oauth2sts_INVALID_NOT_AUTH: 2,
    oauth2sts_NEED_BANK_SUBSIDARY: 3,
    oauth2sts_RECEIVED: 4,
    oauth2sts_IN_PROGRESS: 5,
    oauth2sts_FINAL_COMPLETED: 7,
    oauth2sts_FINAL_CANCEL_BY_USER: 8,
    oauth2sts_FINAL_FAILED_UNSPECIFIED_REASON: 13,
    oauth2sts_FINAL_CANCEL_AUTHROIZATION_EXPIRED: 14,
    oauth2sts_NOT_CUSTOMER_IN_SELECTED_BANK: 20,
    oauth2sts_NOT_CUSTOMER_IN_SWEDBANK_GROUP: 21,
    oauth2sts_CUSTOMER_CONTACT_SWEDBANK: 22,
    oauth2sts_ENUM_LEN: 99
  };

  svs.accountservicesReact.deposit.constants.swedbankExpress.depositStatus = {
    withdsts_NONE: 0,
    withdsts_UNKNOWN_INTERNAL_ISSUE: 1,
    withdsts_RECEIVED: 4,
    withdsts_IN_PROGRESS: 5,
    withdsts_IN_PROGRESS_AUTHENICATED: 6,
    withdsts_FINAL_COMPLETE: 7,
    withdsts_FINAL_CANCEL_USER_INTERRUPT: 8,
    withdsts_FINAL_REJECTED: 9,
    withdsts_FINAL_ERROR: 10,
    withdsts_FINAL_CANCEL_UNKNOWN_REASON: 13,
    withdsts_FINAL_CANCEL_TIMEOUT_SHORT: 21,
    withdsts_FINAL_CANCEL_TIMEOUT_LONG: 22,
    withdsts_ENUM_LEN: 99
  };
  svs.accountservicesReact.deposit.constants.swedbankExpress.bankIdPollType = {
    POLL_CONSENT: 'pollconsent',
    POLL_CONSENT_SELECT_BANK: 'pollselectbank',
    POLL_DEPOSIT: 'polldeposit',
    POLL_CHANGE_BANK: 'pollchangebank'
  };
  svs.accountservicesReact.deposit.constants.swedbankExpress.internalConstants = {
    MAX_NETWORK_RETRIES: 3
  };
  const TRANSLATION = new Map([['DAY', 'dag'], ['WEEK', 'vecka'], ['MONTH', 'månad']]);
  const PERIODS = [...TRANSLATION.keys()];
  svs.accountservicesReact.deposit.depositLimits.constants = {
    PERIODS,
    TRANSLATION
  };
}

 })(window);